import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { placeCreatedRowFirst } from "utils/helpers";
import {
  adminTemplateState,
  adminTemplateTableRow,
  adminTemplateForm,
} from "../types/index";
import { initialState } from "./initialState";

export const sliceKey = "adminTemplateState";

export const AdminTemplateSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    getDocumentList(state) {
      state.loading = true;
    },
    getDocumentSuccess(
      state,
      action: PayloadAction<adminTemplateTableRow[]>,
    ) {
      state.loading = false;
      state.data = action.payload;
    },
    getDocumentFailure(state) {
      state.loading = false;
    },
    createDocument(state, action: PayloadAction<adminTemplateForm>) {
      state.saving = true;
      state.formData = action.payload;
    },
    createDocumentSuccess(
      state,
      action: PayloadAction<adminTemplateTableRow>,
    ) {
      state.saving = false;
      state.isAddModalOpen = false;
      state.data = placeCreatedRowFirst(state.data, action.payload);
      state.formData = initialState.formData;
    },
    createDocumentFailure(state) {
      state.saving = false;
    },
    resetForm(state) {
      state.formData = initialState.formData;
    },
    setFormField(
      state,
      action: PayloadAction<{ name: keyof adminTemplateForm; value: string }>,
    ) {
      state.formData = {
        ...state.formData,
        [action.payload.name]: action.payload.value,
      };
    },
    openAddModal(state) {
      state.isAddModalOpen = true;
    },
    closeAddModal(state) {
      state.isAddModalOpen = false;
      state.saving = false;
    },
  },
});

export const { reducer, actions } = AdminTemplateSlice;
